import {Api} from "./Api";
import {ModelMetadata} from "../Schema/models/ModelMetadata";

export class ModelsApi extends Api {
    async queryModels(): Promise<ModelMetadata[]> {
        return this.newCall<ModelMetadata[]>('models/query')
            .fetchJson()
    }
}